import { render, staticRenderFns } from "./AudioControl.vue?vue&type=template&id=188f14bb&scoped=true"
import script from "./AudioControl.vue?vue&type=script&lang=js"
export * from "./AudioControl.vue?vue&type=script&lang=js"
import style0 from "./AudioControl.vue?vue&type=style&index=0&id=188f14bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188f14bb",
  null
  
)

export default component.exports